<num-availability-status-bar [status]="cell.value"></num-availability-status-bar>
